var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "simditor-wrapper"
  }, [_c('textarea', {
    ref: "editorHolder",
    attrs: {
      "id": "editor",
      "autofocus": "",
      "maxlength": "5000"
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4180bf9a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vueditor/src/main.vue
// module id = null
// module chunks = 